import { Injectable, NgZone, inject } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { BehaviorSubject, catchError, Observable, tap } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { getMessaging } from 'firebase/messaging';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  private readonly messageSource = new BehaviorSubject(null);
  currentMessage = this.messageSource.asObservable();
  currentFCMMessage = new BehaviorSubject(null);
  public subscribe$: Observable<any>;
  token: string;
  private readonly fcmToken = new BehaviorSubject<string | null>(null);
  private readonly refreshInterval = 1 * 60 * 60 * 1000; // 1 hours in milliseconds
  constructor(private readonly ngZone: NgZone, private readonly afMessaging: AngularFireMessaging, private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService) {
    //this.registerServiceWorker();
    this.requestPermission();
    this.setupTokenRefresh();
    //this.listenForServiceWorkerMessages();
    this.listenToMessages();
    //this.receiveMessages();
  }

  private async registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      // 🔹 Unregister existing service workers to avoid duplication
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
        console.log('✅ Unregistered old service worker:', registration);
      }

      // 🔹 Register a new service worker
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js', { scope: '/firebase-cloud-messaging-push-scope/' })
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
          this.requestPermission();
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }

  // Request permission and get token
  requestPermission() {
    if (!('Notification' in window)) {
      console.warn('This browser does not support desktop notification');
      return;
    }
    // this.listenForServiceWorkerMessages();
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        console.log('granted');
        //navigator.serviceWorker.ready.then((serviceWorkerRegistration:any) => {
        this.afMessaging.requestToken.subscribe(
          (token) => {
            console.log('FCM Token:', token);
            this.http.post<any>(`${apiurl}/noti/subscribe`, { token: token, topic: 'all' }).subscribe(x => console.log(x));
            localStorage.setItem('fcm_token', token);
          },
          (error) => console.error('Error getting FCM token in Edge:', error)
        );
        //});
      } else {
        console.warn('Notification permission denied in Edge.');
      }
    });
  }

  setupTokenRefresh() {
    setInterval(async () => {
      console.log('Refreshing FCM Token...');
      await this.requestPermission();
    }, this.refreshInterval);
  }


  receiveMessages() {

    this.afMessaging.messages.subscribe((message) => {
      this.currentFCMMessage.next(message);
    });
  }

  private listenForServiceWorkerMessages() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'MESSAGE_FROM_SW') {
          console.log('enter');
          this.currentFCMMessage.next(event.data.payload);
        }
      });
    } else {
      console.warn("Service Worker is not supported in this browser.");
    }
  }

  private listenToMessages() {
    // // 1. Angular's foreground messages
    // this.afMessaging.messages
    //   .subscribe({
    //     next: (payload) => {
    //       this.ngZone.run(() => {
    //         console.log('Foreground message:', payload);
    //         this.currentFCMMessage.next(payload);
    //       });
    //     },
    //     error: (err) => console.error('FCM error:', err)
    //   });

    // 2. Service worker messages (when Angular misses them)
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'MESSAGE_FROM_SW') {
          this.ngZone.run(() => {
            // console.log('SW relayed message:', event.data.payload);
            this.currentFCMMessage.next(event.data.payload);
          });
        }
      });
    }
  }
}

